module.exports = __webpack_public_path__ + "img/fernanda.c9de666f.jpg";